import { mapEnumToOptions } from '@abp/ng.core';

export enum OrderType {
  Order = 0,
  Return = 1,
  PurchaseOrder = 2,
}

export const orderTypeOptions = mapEnumToOptions(OrderType);
